import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import Utility from '../../util/utilityfunctions';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function TaskListFiltersReducer(state = initialState.taskListFilters, action) {
	switch (action.type) {
		case types.SET_TASK_LIST_MENU_FILTERS: {
			let filters = {...state};

			Object.entries(action.filters).forEach((level) => {
				filters[action.filterKey] = {
					...filters[level[0]],
					...level[1]
				};
			});

			return filters;
		}

		case types.SET_TASK_LIST_MENU_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, explicit undefined is required
				value = null;
			}

			let filters = {...state};

			if (action.filterKey) {
				if (filters[action.filterKey]) {
					filters[action.filterKey] = {...filters[action.filterKey]};
				} else {
					filters[action.filterKey] = {};
				}

				filters[action.filterKey][action.filterItemName] = value;

				if (!Utility.hasValue(filters[action.filterKey][action.filterItemName])) {
					delete filters[action.filterKey][action.filterItemName];
				}
			} else {
				filters[action.filterItemName] = value;
			}

			// Page number must be rest to 1.
			filters.currentPage = 1;

			return {
				...state,
				...filters
			};
		}

		case types.SET_TASK_LIST_MULTIPLE_MENU_FILTER: {
			let filters = {...state};
			filters[action.filterKey] = {...action.filters};
			if (action.assignmentStatus && _.size(action.assignmentStatus) > 0) {
				filters = {
					...filters,
					...action.assignmentStatus
				};
			}
			if (action.taskStatus && _.size(action.taskStatus) > 0) {
				filters = {
					...filters,
					...action.taskStatus
				};
			}

			if (action.categoryId) {
				filters = {
					...filters,
					...action.categoryId
				};
			}

			if (action.subcategoryId) {
				filters = {
					...filters,
					...action.subcategoryId
				};
			}

			// Page number must be rest to 1.
			filters.currentPage = 1;
			return filters;
		}

		case types.CLEAR_TASK_LIST_MENU_FILTERS: {
			let filters = {...state};
			filters[action.filterKey] = {};
			filters.currentPage = 1;

			return filters;
		}
		case types.SET_TASK_LIST_FILTERS: {
			let taskListFilters = action.filters;
			if (action.filterType) {
				let newFilter = [];
				if (taskListFilters[action.filterType]) {
					newFilter = _.cloneDeep(taskListFilters[action.filterType]);
					newFilter.push(action.filterValue);
				} else {
					newFilter.push(action.filterValue);
				}
				taskListFilters[action.filterType] = newFilter;
			}
			return {...state, ...taskListFilters, quickFilterId: action.quickFilterId};
		}

		case types.RESET_TASK_CATEGORY: {
			let taskListFilters = action.filters;
			if (action.filterType) {
				let newFilter = [];
				if (taskListFilters[action.filterType]) {
					newFilter = _.cloneDeep(taskListFilters[action.filterType]);
					newFilter.push(action.filterValue);
				} else {
					newFilter.push(action.filterValue);
				}
				taskListFilters[action.filterType] = newFilter;
			}
			return {...state, ...taskListFilters};
		}
		case types.RESET_TASK_LIST_FILTERS: {
			let taskListFilters = action.filters;
			if (action.filterType) {
				let newFilter = [];
				if (taskListFilters[action.filterType]) {
					newFilter = _.cloneDeep(taskListFilters[action.filterType]);
					newFilter.push(action.filterValue);
				} else {
					newFilter.push(action.filterValue);
				}
				taskListFilters[action.filterType] = newFilter;
			}
			return {...initialState.taskListFilters, ...taskListFilters};
		}
		case types.CLEAR_TASK_LIST_FILTERS: {
			if (action.data) {
				return Object.assign({}, initialState.taskListFilters, action.data);
			}
			return initialState.taskListFilters;
		}
		default:
			return state;
	}
}
